import { logger } from '@springtree/eva-sdk-core-logger';
import {
  Interceptor,
  IResponseInterceptor,
} from '@springtree/eva-sdk-core-service';
import { IEvaApplicationTokenAction } from '@springtree/eva-sdk-redux-store-builder/src/action/current-user';
import { Store } from 'redux';

/**
 * This interceptor listens to all service responses for a new application token
 *
 * @export
 * @class AppTokenInterceptor
 */
export class ApplicationTokenInterceptor extends Interceptor {

  /**
   * Creates an instance of the EvaAvailableServices interceptor
   */
  constructor(
    private store: Store,
  ) {
    super('EVA:ReduxStoreApplicationToken');
    this.priority = 5;
  }

  /**
   * The response interceptor implementation.
   * Available as a public property for direct use
   * By returning a fetch Response we will prevent the service call from going out
   *
   * @type {IResponseInterceptor}
   */
  public responseInterceptor: IResponseInterceptor = {
    hook: async (request, options, response) => {

      response.headers.forEach((value, name) => {
        if (`${name}`.toLowerCase() === 'EVA-App-Token'.toLowerCase()) {
          // EVA Application tokens are usually returned on create order
          // calls to provide secure access to anonymous orders
          //
          logger.log(`[EVA:SDK] persisting new application token ${value}`)();
          const applicationTokenAction: IEvaApplicationTokenAction = {
            type: 'APPLICATION_TOKEN',
            payload: { token: value },
          };
          this.store.dispatch(applicationTokenAction);
        }
      });

      // IMPORTANT: Do not return a response here or any other interceptors will fail to fire
    },
  };
}
